import { useSelector } from 'react-redux';
import utils from 'utils';
import {
  inPathAdditionalDriversSelector,
  getNumberAdditionalDriversAllowed,
  additionalDriverReservationDetailsSelector,
  reservationVehicleRateSelector,
  priceSummarySelector,
  reservationHasAdditionalDriverFreeSpouseSelector,
} from 'selectors/reservationFlowSelectors';
import { isDestinationCurrencySelected } from 'selectors/vehicleSelectSelectors';

const useAdditionalDriversList = () => {
  const maxAdditionalDrivers = useSelector(getNumberAdditionalDriversAllowed) || 0;
  const addtlDriverDetails = useSelector(additionalDriverReservationDetailsSelector);
  const vehicleRates = useSelector(reservationVehicleRateSelector);
  const hasAdditionalDriverFreeSpouse = useSelector(reservationHasAdditionalDriverFreeSpouseSelector);
  const driversList = useSelector(inPathAdditionalDriversSelector);
  const priceSummary = useSelector(priceSummarySelector);
  const destinationCurrencySelected = useSelector(isDestinationCurrencySelected);
  const allowMoreDrivers = driversList.length < maxAdditionalDrivers;
  const { number_of_free_additional_drivers, rate_amount_view, rate_type } = addtlDriverDetails;
  const otherDriverCost = utils.getFormattedPrice(rate_amount_view);
  const paymentLineItems = vehicleRates?.price_summary?.payment_line_items || {};
  const fees = paymentLineItems?.FEE || [];
  const additionalDriverPrices = paymentLineItems?.ADDITIONAL_DRIVER || [];

  const hasYoungDriverFee = individualId =>
    !!individualId && fees.some(fee => fee?.driver_individual_id === individualId);

  const drivers = driversList.map((driver, index) =>
    Object.assign(driver, {
      rate_amount_view: destinationCurrencySelected
        ? additionalDriverPrices[index]?.rate_amount_payment
        : additionalDriverPrices[index]?.rate_amount_view,
      total_amount_view: destinationCurrencySelected
        ? additionalDriverPrices[index]?.total_amount_payment
        : additionalDriverPrices[index]?.total_amount_view,
    })
  );

  return {
    additionalDriverPrices,
    hasYoungDriverFee,
    fees,
    driversList: drivers,
    freeSpouse: hasAdditionalDriverFreeSpouse,
    allowMoreDrivers,
    maxAdditionalDrivers,
    numberOfFreeDrivers: number_of_free_additional_drivers,
    otherDriverCost,
    rateType: rate_type,
    totalPrice: priceSummary?.estimated_total_additional_driver_view?.format,
  };
};

export default useAdditionalDriversList;
